import TermsOfUsePage from "./TermsOfUsePage";
import authRoles from "../../auth/authRoles";

const TermsOfUseConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: "terms-of-use",
      element: <TermsOfUsePage />,
    },
  ],
};

export default TermsOfUseConfig;
